export default "__VITE_ASSET__BsTSwhra__"